import { render, staticRenderFns } from "./search-saved-messages-ctrl.vue?vue&type=template&id=a5d66f48&scoped=true&"
import script from "./search-saved-messages-ctrl.vue?vue&type=script&lang=js&"
export * from "./search-saved-messages-ctrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d66f48",
  null
  
)

export default component.exports